import { useQuery } from "@tanstack/react-query";

import { useIsVendor } from "~/shared/hooks/use-is-vendor.ts";
import type { BillingCustomerAssociation } from "~/shared/schemas/billing-customer-schema.ts";
import { billingCustomerAssociationSchema } from "~/shared/schemas/billing-customer-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

export const useBillingCustomers = (customerId: number | undefined) => {
	const { isVendor } = useIsVendor();

	return useQuery<BillingCustomerAssociation[]>({
		queryKey: ["billingCustomers", customerId],
		queryFn: async () => {
			if (!customerId) return [];

			const route = apiRoutes.BILLINGCUSTOMERS.replace(
				":customerId",
				String(customerId),
			);
			const result = await getAndValidate(
				route,
				billingCustomerAssociationSchema.array(),
			);

			if (result.success && result.data.length > 0) {
				return result.data;
			}

			// Fallback: if no associated billing customers, default to the tendering customer
			return [];
		},
		enabled: !!customerId && customerId > 0 && !isVendor,
		staleTime: 1000 * 60 * 5,
		refetchOnWindowFocus: false,
	});
};
